import { Flex, Tab, TabList, Tabs } from "@chakra-ui/react";
import { AvatarModes } from "src/modules/avatar/enum";
import SvgContainer from "src/components/SvgContainer";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { useSelector } from "react-redux";
import { usePurchaseContext } from "src/modules/purchase/PurchaseContext";
import { useTranslation } from "react-i18next";

import { ReactComponent as SelectedIcon } from "src/icons/selected.svg";
import { ReactComponent as LockIcon } from "src/icons/lock.svg";

const modes = {
  0: AvatarModes.illustration,
  1: AvatarModes.profileImage
};

export default function AvatarModeSelect({
  onChange,
  mode = AvatarModes.illustration
}) {
  const { t } = useTranslation();
  const isFreeVersion = useSelector(isFreemium);
  const purchase = usePurchaseContext();

  const checkForPremium = () => {
    if (isFreeVersion) {
      purchase.open({ content: "photoMode" });
    }
  };

  const handleChange = (index) => {
    const previewMode = modes[index];
    onChange(previewMode);
  };

  const defaultIndex = Object.keys(modes).findIndex(
    (key) => modes[key] === mode
  );

  const icon = <SvgContainer icon={SelectedIcon} fill="primary" />;
  return (
    <Flex
      borderRadius="12px"
      p="4px"
      bg="hover"
      w="200px"
      pos="absolute"
      top="16px"
    >
      <Tabs
        onClick={checkForPremium}
        onChange={handleChange}
        w="100%"
        defaultIndex={defaultIndex}
      >
        <TabList>
          <Tab w="50%" columnGap="2px" isDisabled={isFreeVersion}>
            {mode === AvatarModes.illustration && icon}
            <Flex align="center">{t("avatar")}</Flex>
          </Tab>

          <Tab
            w="50%"
            columnGap="2px"
            pos="relative"
            isDisabled={isFreeVersion}
          >
            {mode === AvatarModes.profileImage && icon}
            <Flex align="center" columnGap="2px">
              <span>{t("photo")}</span>
              {isFreeVersion && (
                <SvgContainer fill="mediumEmphasis" icon={LockIcon} />
              )}
            </Flex>
          </Tab>
        </TabList>
      </Tabs>
    </Flex>
  );
}
